import { generateId } from "@msuite/utils/strings";
import React from "react";
import type { TooltipPayload } from "recharts";
import { DataGrid } from "../../data-grid";

export function TooltipContent({
	payload,
	label,
	formatter,
	displayKeyMap,
}: {
	payload?: TooltipPayload;
	label?: string | number;
	formatter?: (value: number | undefined) => React.ReactNode;
	displayKeyMap: Record<string, string>;
}) {
	return (
		<div className="min-w-[200px] text-xs card">
			<DataGrid>
				{label && (
					<React.Fragment>
						<div className="col-span-2">
							<p>{label}</p>
						</div>
						<DataGrid.Divider />
					</React.Fragment>
				)}
				{payload?.map((entry) => {
					const dataKey = String(entry.dataKey ?? "");
					const displayKey = displayKeyMap[dataKey] ?? dataKey;

					return (
						<DataGrid.Row key={generateId()}>
							<DataGrid.Label>{displayKey}</DataGrid.Label>
							<DataGrid.Value className="tabular-nums">
								{formatter ? formatter(entry.value as number | undefined) : entry.value}
							</DataGrid.Value>
						</DataGrid.Row>
					);
				})}
			</DataGrid>
		</div>
	);
}
